export default __webpack_public_path__ + "static/media/Eb1.22bc32e5.mp3";